<div class="container-modal">
    <div class="header-container">
        <p class="close grey" *ngIf="data.rapidScore"><img src="./assets/logos/close-black.svg" (click)="closeModal()" alt=""></p>
        <p class="close" *ngIf="!data.rapidScore"><img src="./assets/logos/close.svg" (click)="closeModal()" alt=""></p>
        <p class="icon-info" *ngIf="!data.rapidScore"><img src="assets/temporals/information-white.svg" alt=""></p>
        <p class="tittle">{{ 'MODAL_LOGIN.TITLE' | translate }}</p>
    </div>
    <div class="body-modal">
        <div class="list">
            <p>{{ 'MODAL_LOGIN.TEXT1' | translate }}</p>
            <p>{{ 'MODAL_LOGIN.TEXT2' | translate }}</p>
            <p>{{ 'MODAL_LOGIN.TEXT3' | translate }}</p>
        </div>
    </div>

</div>